'use client';

/**
 * Yotti Landing Page
 *
 * Showcase website for Yotti Discord bot featuring:
 * - Loading screen animation
 * - Hero section with 3D cubes background
 * - Features showcase
 * - Interactive command directory with search
 * - Live demo section
 * - Antinuke security showcase
 * - Comparison table
 * - FAQ section
 * - Footer
 */

import { LoadingScreen } from '@/components/loading-screen';
import { HeroSection } from '@/components/hero-section';
import { FeaturesShowcase } from '@/components/features-showcase';
import { CommandDirectory } from '@/components/command-directory';
import { LiveDemo } from '@/components/live-demo';
import { AntinukeShowcase } from '@/components/antinuke-showcase';
import { ComparisonTable } from '@/components/comparison-table';
import { FAQSection } from '@/components/faq-section';
import { Footer } from '@/components/footer';

export default function YottiLandingPage() {
  return (
    <>
      {/* Loading screen - shows for 1.5 seconds */}
      <LoadingScreen />

      {/* Main content */}
      <main className="bg-[#0f0f0f] min-h-screen">
        <HeroSection />
        <FeaturesShowcase />
        <CommandDirectory />
        <LiveDemo />
        <AntinukeShowcase />
        <ComparisonTable />
        <FAQSection />
        <Footer />
      </main>
    </>
  );
}
